module.exports = __webpack_public_path__ + "static/media/vimeo.9d516b2a.svg";